import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import { useState, useMemo, useEffect } from 'react';
import { connect } from 'react-redux';
import { useRouter } from 'next/router';
import { CSSTransition } from 'react-transition-group';
import { get } from '@cullylarson/f';
import { classnames } from '@@client/lib/classes';
import { preventDefault } from '@@client/lib/events';
import { TriggerManager } from '@@client/lib/util';
import { routeToTop } from '@@client/lib/nextjs';
import { buildSearchQuery } from './parts-helper';
import { labelStyle, subHeadingStyle } from '@@client/parts/styles';
import loadPartTypeNameList from '@@client/parts/part-type-name/loadPartTypeNameList';
import loadApplicationListSidebar from './application/loadApplicationListSidebar';
import FormSelect from '@@client/components/FormSelect';
import SlideOpen from '@@client/app/SlideOpen';
import NaturalSearchForm from '@@client/parts/NaturalSearchForm';
import PartSearchModal from './PartSearchModal';

var Criteria = function Criteria(_ref) {
  var idPrefix = _ref.idPrefix,
      vehicleSummary = _ref.vehicleSummary,
      partTypeOptions = _ref.partTypeOptions,
      partTypeValue = _ref.partTypeValue,
      onPartTypeChange = _ref.onPartTypeChange,
      haveApplications = _ref.haveApplications,
      applicationOptions = _ref.applicationOptions,
      onApplicationChange = _ref.onApplicationChange,
      applicationValue = _ref.applicationValue,
      onChangeSearchVehicleClick = _ref.onChangeSearchVehicleClick,
      _ref$onSearchQuerySub = _ref.onSearchQuerySubmit,
      onSearchQuerySubmit = _ref$onSearchQuerySub === void 0 ? function () {} : _ref$onSearchQuerySub,
      onSubmit = _ref.onSubmit;
  var router = useRouter();
  var searchQuery = get('q', '', router.query);
  var partTypeSelectElId = idPrefix + '-one-part-select-part-type';
  var applicationSelectElId = idPrefix + '-one-part-select-application';
  var searchQueryElId = idPrefix + '-search-query';

  var handleParam = function handleParam(setValue) {
    return function (e) {
      return e && e.target ? setValue(e.target.value) : setValue(e);
    };
  };

  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("h3", {
      className: "jsx-742878424" + " " + (subHeadingStyle.className || ""),
      children: "Search Criteria:"
    }), !searchQuery ? null : /*#__PURE__*/_jsxs("div", {
      className: "jsx-742878424" + " " + 'search-query',
      children: [/*#__PURE__*/_jsx("label", {
        htmlFor: searchQueryElId,
        className: "jsx-742878424" + " " + (labelStyle.className || ""),
        children: "Search Query"
      }), /*#__PURE__*/_jsx(NaturalSearchForm, {
        id: searchQueryElId,
        styleDef: null,
        onSubmit: onSearchQuerySubmit,
        children: /*#__PURE__*/_jsx("div", {
          className: "jsx-742878424" + " " + 'actions',
          children: /*#__PURE__*/_jsx("button", {
            type: "submit",
            className: "jsx-742878424" + " " + 'btn btn--blue--dark',
            children: "Search"
          })
        })
      })]
    }), /*#__PURE__*/_jsxs("form", {
      onSubmit: onSubmit,
      className: "jsx-742878424",
      children: [/*#__PURE__*/_jsx("label", {
        htmlFor: partTypeSelectElId,
        className: "jsx-742878424" + " " + (labelStyle.className || ""),
        children: "Current Part Search"
      }), /*#__PURE__*/_jsx(FormSelect, {
        id: partTypeSelectElId,
        name: "partType",
        placeholder: "Select Part...",
        value: partTypeValue,
        options: partTypeOptions,
        noOptionsMessage: "No part types found",
        onChange: handleParam(onPartTypeChange)
      }), /*#__PURE__*/_jsx(CSSTransition, {
        "in": haveApplications,
        unmountOnExit: true,
        classNames: "application-transition",
        timeout: 300,
        children: /*#__PURE__*/_jsxs("div", {
          "aria-hidden": haveApplications ? 'false' : 'true',
          className: "jsx-742878424" + " " + (classnames('applications', haveApplications ? 'is-open' : 'not-open') || ""),
          children: [/*#__PURE__*/_jsx("label", {
            htmlFor: applicationSelectElId,
            className: "jsx-742878424" + " " + (labelStyle.className || ""),
            children: "Options"
          }), /*#__PURE__*/_jsx(FormSelect, {
            id: applicationSelectElId,
            name: "application",
            placeholder: "Select Option...",
            value: applicationValue,
            options: applicationOptions,
            noOptionsPlaceholder: "NO OPTIONS",
            noOptionsMessage: "No options",
            onChange: handleParam(onApplicationChange)
          })]
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "jsx-742878424" + " " + 'actions',
        children: /*#__PURE__*/_jsx("button", {
          type: "submit",
          className: "jsx-742878424" + " " + 'btn btn--blue--dark',
          children: "Find parts"
        })
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: "jsx-742878424" + " " + 'vehicle',
      children: [/*#__PURE__*/_jsx("div", {
        className: "jsx-742878424" + " " + (classnames('vehicle-label', labelStyle.className) || ""),
        children: "Current Vehicle Search"
      }), /*#__PURE__*/_jsx("div", {
        className: "jsx-742878424" + " " + 'summary',
        children: vehicleSummary || /*#__PURE__*/_jsx("em", {
          className: "jsx-742878424",
          children: "No vehicle selected."
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "jsx-742878424" + " " + 'actions',
        children: /*#__PURE__*/_jsx("button", {
          onClick: onChangeSearchVehicleClick,
          className: "jsx-742878424" + " " + (classnames('m--no-btn', 'm--clickable', subHeadingStyle.className) || ""),
          children: "Change Search Vehicle"
        })
      })]
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "742878424",
      children: [".search-query.jsx-742878424{margin-bottom:20px;}", "@media(min-width:768px){.search-query.jsx-742878424{display:none;}}", ".search-query.jsx-742878424 form{margin:10px 0;}", ".search-query.jsx-742878424 .actions.jsx-742878424{margin-top:10px;}", "form.jsx-742878424{margin-bottom:18px;padding-bottom:18px;border-bottom:1px solid #9BA3C3;}", "form.jsx-742878424 .field{margin-bottom:0;}", "form.jsx-742878424 .actions.jsx-742878424{margin-top:10px;}", "label.jsx-742878424{margin-bottom:8px;}", ".applications.jsx-742878424{margin-top:15px;}", ".applications.not-open.jsx-742878424{overflow:hidden;}", ".applications.application-transition-enter.jsx-742878424{-webkit-transition:all 300ms ease;-webkit-transition:all 300ms ease;transition:all 300ms ease;overflow:hidden;margin:0;opacity:0;max-height:0;}", ".applications.application-transition-enter-done.jsx-742878424,.applications.application-transition-enter-active.jsx-742878424{opacity:1;margin-top:15px;max-height:275px;}", ".applications.application-transition-enter-done.jsx-742878424{overflow:visible;}", ".applications.application-transition-exit.jsx-742878424{-webkit-transition:all 300ms ease;-webkit-transition:all 300ms ease;transition:all 300ms ease;opacity:0;margin:0;max-height:0;}", ".applications.application-transition-done.jsx-742878424{overflow:hidden;}", ".vehicle-label.jsx-742878424{margin-bottom:8px;}", ".summary.jsx-742878424{font-weight:700;margin-bottom:8px;}", ".vehicle.jsx-742878424 button.jsx-742878424:hover{-webkit-text-decoration:underline;text-decoration:underline;}"]
    })]
  });
};

var haveApplicationOption = function haveApplicationOption(application, entities) {
  return entities.some(function (x) {
    return x.hollanderNumber === application;
  });
};

var mapStateToProps = function mapStateToProps(_ref2) {
  var _ref2$parts = _ref2.parts,
      partTypeName = _ref2$parts.partTypeName,
      application = _ref2$parts.application;
  return {
    partTypeNameStore: partTypeName,
    applicationStore: application
  };
};

var mapDispatchToProps = function mapDispatchToProps() {
  return {};
};

var PartSearchFormSidebar = function PartSearchFormSidebar(_ref3) {
  var partTypeNameStore = _ref3.partTypeNameStore,
      applicationStore = _ref3.applicationStore,
      partTypeSlug = _ref3.partTypeSlug,
      year = _ref3.year,
      make = _ref3.make,
      carline = _ref3.carline,
      application = _ref3.application,
      searchQuery = _ref3.searchQuery,
      _ref3$action = _ref3.action,
      action = _ref3$action === void 0 ? '/parts' : _ref3$action,
      _ref3$doing = _ref3.doing,
      doing = _ref3$doing === void 0 ? false : _ref3$doing;
  loadPartTypeNameList();
  var router = useRouter();

  var _useState = useState(partTypeSlug || ''),
      localPartTypeSlug = _useState[0],
      setPartTypeSlug = _useState[1];

  var _useState2 = useState(application || ''),
      localApplication = _useState2[0],
      setApplication = _useState2[1];

  var _useState3 = useState(application || ''),
      lastSelectedApplication = _useState3[0],
      setLastSelectedApplication = _useState3[1];

  var _useState4 = useState(false),
      isModalOpen = _useState4[0],
      setIsModalOpen = _useState4[1];

  loadApplicationListSidebar(year, carline, localPartTypeSlug);
  var partTypeName = useMemo(function () {
    var _partTypeNameStore$li;

    return (_partTypeNameStore$li = partTypeNameStore.list.entities.find(function (x) {
      return x.slug === localPartTypeSlug;
    })) === null || _partTypeNameStore$li === void 0 ? void 0 : _partTypeNameStore$li.name;
  }, [localPartTypeSlug, partTypeNameStore.list.entities]);
  var applicationName = useMemo(function () {
    var _applicationStore$lis;

    return (_applicationStore$lis = applicationStore.listSidebar.entities.find(function (x) {
      return x.hollanderNumber === localApplication;
    })) === null || _applicationStore$lis === void 0 ? void 0 : _applicationStore$lis.label;
  }, [localApplication, applicationStore.listSidebar.entities]);
  var vehicleSummary = [year, make, carline].join(' ').trim();
  var criteriaSummary = searchQuery ? "\"".concat(searchQuery, "\"") : [year, make, carline, partTypeName, applicationName].join(' ').trim();
  var partTypeOptions = useMemo(function () {
    return partTypeNameStore.list.doing ? [{
      value: '',
      label: 'Loading...'
    }] : partTypeNameStore.list.entities.map(function (x) {
      return {
        value: x.slug,
        label: x.name
      };
    });
  }, [partTypeNameStore.list.doing]);
  var haveApplications = Boolean(applicationStore.listSidebar.entities.length);
  var applicationOptions = useMemo(function () {
    return applicationStore.listSidebar.doing ? [{
      value: '',
      label: 'Loading...'
    }] : applicationStore.listSidebar.entities.map(function (x) {
      return {
        value: x.hollanderNumber,
        label: x.label
      };
    });
  }, [applicationStore.listSidebar.entities]);

  var handleModalChange = function handleModalChange(_ref4) {
    var partTypeSlug = _ref4.partTypeSlug,
        application = _ref4.application;
    setPartTypeSlug(partTypeSlug || '');
    setApplication(application || '');
    setLastSelectedApplication(application || '');
  };

  var handleSearchQuerySubmit = function handleSearchQuerySubmit() {
    closeCriteriaTriggerManager.trigger();
  };

  var handleSearchMobalSubmit = function handleSearchMobalSubmit() {
    setIsModalOpen(false);
    closeCriteriaTriggerManager.trigger();
  };

  var handleSubmit = preventDefault(function () {
    closeCriteriaTriggerManager.trigger();
    var query = buildSearchQuery(localPartTypeSlug, year, make, carline, localApplication);
    routeToTop(router, {
      pathname: action,
      query: query
    });
  });
  var clearSearchTriggerManager = useMemo(TriggerManager, []);
  var toggleCriteriaTriggerManager = useMemo(TriggerManager, []);
  var closeCriteriaTriggerManager = useMemo(TriggerManager, []); // need to clear the application when we don't have any options. however, we don't want to clear it
  // on initial page load. simple solution: clear if no options, but then select the originally provided
  // option if it's available.

  useEffect(function () {
    var entities = applicationStore.listSidebar.entities;

    if (!entities.length) {
      setApplication('');
    } else if (haveApplicationOption(lastSelectedApplication, entities)) {
      setApplication(lastSelectedApplication || '');
    } else {
      setApplication('');
    }
  }, [applicationStore.listSidebar.entities]); // if the search query is present, clear the search because we won't be matching against the form value, just the query

  useEffect(function () {
    if (searchQuery) {
      clearSearchTriggerManager.trigger();
      setPartTypeSlug('');
      setApplication('');
      setLastSelectedApplication('');
    }
  }, [searchQuery]); // if the partTypeSlug provided ever changes (e.g. because the URL query changes), we need to reflect that

  useEffect(function () {
    setPartTypeSlug(partTypeSlug || '');
  }, [partTypeSlug]); // if the application provided ever changes (e.g. because the URL query changes), we need to reflect that

  useEffect(function () {
    setApplication(application || '');
    setLastSelectedApplication(application || '');
  }, [application]);
  var slideOpenId = 'slide-open-search';
  if (doing) return null;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PartSearchModal, {
      isOpen: isModalOpen,
      onClose: function onClose() {
        return setIsModalOpen(false);
      },
      partTypeSlug: localPartTypeSlug,
      year: year,
      make: make,
      carline: carline,
      application: localApplication,
      onChange: handleModalChange,
      onSubmit: handleSearchMobalSubmit,
      doClearSearch: clearSearchTriggerManager.setCallback
    }), /*#__PURE__*/_jsxs("div", {
      className: "jsx-1468511527" + " " + 't-sm edit-search',
      children: [/*#__PURE__*/_jsx("span", {
        className: "jsx-1468511527" + " " + 'label',
        children: "Results for:"
      }), /*#__PURE__*/_jsx("span", {
        className: "jsx-1468511527" + " " + 'criteria',
        children: criteriaSummary
      }), /*#__PURE__*/_jsx("span", {
        className: "jsx-1468511527" + " " + 'sep',
        children: "|"
      }), /*#__PURE__*/_jsx("button", {
        "aria-haspopup": "true",
        "aria-controls": slideOpenId,
        onClick: toggleCriteriaTriggerManager.trigger,
        className: "jsx-1468511527" + " " + 'm--as-link',
        children: "Edit Search"
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "jsx-1468511527" + " " + 'container-desktop a-md',
      children: /*#__PURE__*/_jsx(Criteria, {
        idPrefix: "search-desktop",
        vehicleSummary: vehicleSummary,
        partTypeOptions: partTypeOptions,
        partTypeValue: localPartTypeSlug,
        onPartTypeChange: setPartTypeSlug,
        haveApplications: haveApplications,
        applicationOptions: applicationOptions,
        onApplicationChange: setApplication,
        applicationValue: localApplication,
        onChangeSearchVehicleClick: function onChangeSearchVehicleClick() {
          return setIsModalOpen(true);
        },
        onSearchQuerySubmit: handleSearchQuerySubmit,
        onSubmit: handleSubmit
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "jsx-1468511527" + " " + 'container-mobile t-sm',
      children: /*#__PURE__*/_jsx(SlideOpen, {
        id: slideOpenId,
        doTriggerToggle: toggleCriteriaTriggerManager.setCallback,
        doTriggerClose: closeCriteriaTriggerManager.setCallback,
        children: /*#__PURE__*/_jsx("div", {
          className: "jsx-1468511527" + " " + 'inner',
          children: /*#__PURE__*/_jsx(Criteria, {
            idPrefix: "search-mobile",
            vehicleSummary: vehicleSummary,
            partTypeOptions: partTypeOptions,
            partTypeValue: localPartTypeSlug,
            onPartTypeChange: setPartTypeSlug,
            haveApplications: haveApplications,
            applicationOptions: applicationOptions,
            onApplicationChange: setApplication,
            applicationValue: localApplication,
            onChangeSearchVehicleClick: function onChangeSearchVehicleClick() {
              return setIsModalOpen(true);
            },
            onSearchQuerySubmit: handleSearchQuerySubmit,
            onSubmit: handleSubmit
          })
        })
      })
    }), labelStyle.styles, subHeadingStyle.styles, /*#__PURE__*/_jsx(_JSXStyle, {
      id: "1468511527",
      children: [".edit-search.jsx-1468511527{padding:10px;background:#F0F1F6;}", ".edit-search.jsx-1468511527 .label.jsx-1468511527{padding-right:10px;}", ".edit-search.jsx-1468511527 .criteria.jsx-1468511527{font-weight:700;}", ".edit-search.jsx-1468511527 .sep.jsx-1468511527{font-weight:700;padding:0 10px;}", ".edit-search.jsx-1468511527 button.jsx-1468511527{font-weight:700;-webkit-text-decoration:none;text-decoration:none;}", "h3.jsx-1468511527{margin-top:0;margin-bottom:5px;}", ".container-desktop.jsx-1468511527{padding:10px 20px;background:white;}", ".container-mobile.jsx-1468511527 .slide-open{border:0;padding:0;}", "@media(max-width:767px){.inner.jsx-1468511527{margin-top:10px;padding:15px;border:1px solid #CCD0E0;}}"]
    })]
  });
};

export default connect(mapStateToProps, mapDispatchToProps)(PartSearchFormSidebar);